import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_4 = { class: "btn btn-light mr-2" }
const _hoisted_5 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "mt-5 font-weight-light" }
const _hoisted_9 = { class: "lead" }
const _hoisted_10 = { class: "table table-hover mt-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "btn btn-outline-primary" }
const _hoisted_17 = {
  key: 1,
  class: "container"
}
const _hoisted_18 = {
  key: 2,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "btn btn-secondary" }
const _hoisted_22 = {
  key: 3,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _component_WeightsViewerDialog = _resolveComponent("WeightsViewerDialog")!
  const _component_PanelistConsistencyAnalysisDialog = _resolveComponent("PanelistConsistencyAnalysisDialog")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_WeightsViewerDialog, {
      propOpened: _ctx.weightsViewerOpened === true,
      propRm: _ctx.weightsViewer,
      onExportPanelistWeights: _ctx.handleExportWeightsToXlsFromPanelistVotesCommand,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.weightsViewerOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm", "onExportPanelistWeights"]),
    _createVNode(_component_PanelistConsistencyAnalysisDialog, {
      propOpened: _ctx.panelistConsistencyAnalysisOpened === true,
      propRm: _ctx.panelistConsistencyAnalysis,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.panelistConsistencyAnalysisOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm"]),
    (_ctx.viewTemplate === 'default')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", _hoisted_3, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Join Meeting", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.rm.MeetingUrl]
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[7] || (_cache[7] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light dropdown-toggle",
                    "data-toggle": "dropdown"
                  }, " My votes ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRespondentConsistencyAnalysis && _ctx.showRespondentConsistencyAnalysis(...args)))
                    }, "Check consistency"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showWeightsViewer && _ctx.showWeightsViewer(...args)))
                    }, "View weights"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleExportPanelistVotesToXlsCommand && _ctx.handleExportPanelistVotesToXlsCommand(...args)))
                    }, "Download to xls")
                  ])
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("a", {
                  class: "btn btn-light",
                  href: "https://www.transparentchoice.com/user-guide/respondents-weights",
                  title: "Respondents guide: Criteria Weights",
                  target: "_blank"
                }, [
                  _createElementVNode("i", {
                    class: "fa fa-info",
                    "aria-hidden": "true"
                  })
                ], -1 /* CACHED */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, "Survey: " + _toDisplayString(_ctx.rm.SurveyName), 1 /* TEXT */),
            _createElementVNode("p", null, "Weight " + _toDisplayString(_ctx.rm.CriteriaCount) + " criteria grouped into " + _toDisplayString(_ctx.rm.Contexts.length) + " contexts by making " + _toDisplayString(_ctx.rm.SurveyQuestionsCount) + " pairwise comparisons.", 1 /* TEXT */),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.rm.SurveyDescription), 1 /* TEXT */),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("th", null, "Context", -1 /* CACHED */)),
                  _createElementVNode("th", null, [
                    _createElementVNode("a", {
                      class: "pointer",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.orderByProgressAsc = !_ctx.orderByProgressAsc))
                    }, "Progress")
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteriaView, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "text-dark",
                        onClick: ($event: any) => (_ctx.showCriterionDetails(c))
                      }, _toDisplayString(c.Name), 9 /* TEXT, PROPS */, _hoisted_11),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", null, _toDisplayString(c.Path), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "progress-bar",
                          role: "progressbar",
                          style: _normalizeStyle({ width: c.Progress + '%' }),
                          title: c.Progress
                        }, null, 12 /* STYLE, PROPS */, _hoisted_14)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Weight", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, c.EvaluationUrl]
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("h3", { class: "text-center" }, [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
            _createTextVNode(" Loading...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'closed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "card-title" }, "Survey is closed", -1 /* CACHED */)),
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to open this survey or go to the meeting.", -1 /* CACHED */)),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_21, [...(_cache[15] || (_cache[15] = [
                _createTextVNode("Go to the meeting", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.rm.MeetingUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'empty')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h5", _hoisted_25, "Empty survey: " + _toDisplayString(_ctx.rm.SurveyName), 1 /* TEXT */),
              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "card-text lead" }, "Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.", -1 /* CACHED */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}